import {
  trackGAEvent,
  createGenericSelectContentEvent,
  EventObject,
} from '@moonpig/web-core-analytics'
import { createReminderSuggestionEvent } from './analytics'

const departmentToCategory = (department?: string) => {
  switch (department?.toLowerCase()) {
    case 'all_gifts':
      return 'gifts'
    case 'all_flowers_and_plants':
      return 'flowers'
    default:
      return 'cards'
  }
}

export const trackClearSearchEvent = () => {
  trackGAEvent({
    event: 'search_input_clear',
    event_data: {
      category: 'search',
      action: 'search input clear',
      label: 'search bar',
      non_interaction: true,
      value: undefined,
    },
  })
}

export const trackSuggestionViewEvent = ({
  searchValue,
  count,
  department,
  departmentSuggestionsEnabled = false,
}: {
  department: string
  searchValue: string
  count: number
  departmentSuggestionsEnabled?: boolean
}) => {
  trackGAEvent({
    event: 'search_suggestion',

    event_data: {
      category: 'search',
      action: 'suggestions displayed',
      label: 'input',
      non_interaction: true,
      value: count,
    },

    results_data: {
      number_of_results: count,
      product_category: departmentSuggestionsEnabled
        ? department.toLowerCase()
        : departmentToCategory(department),
      results_list: searchValue.toLowerCase(),
      suggestion_type: undefined,
      input_type: 'keyword',
    },
  })
}

export const trackSuggestionClickEvent = ({
  suggestion,
  position,
  count,
  department,
  type,
  departmentSuggestionsEnabled = false,
}: {
  suggestion: string
  department: string
  position: number
  count: number
  type: 'navigational' | 'search'
  departmentSuggestionsEnabled?: boolean
}) => {
  const category = departmentSuggestionsEnabled
    ? department.toLowerCase()
    : departmentToCategory(department)
  trackGAEvent({
    event: 'search_suggestion_click',

    event_data: {
      category: 'search',
      action: 'suggestion clicked',
      label: `${suggestion} | ${position}/${count} | ${category}`.toLowerCase(),
      non_interaction: true,
      value: undefined,
    },

    results_data: {
      index: position,
      number_of_results: count,
      product_category: category,
      results_list: suggestion.toLowerCase(),
      input_type: 'facet suggestion',
      suggestion_type: type,
    },
  })
}

export const trackSuggestionsTabSelectedEvent = (tab: string) => {
  trackGAEvent(
    createGenericSelectContentEvent({
      eventCategory: 'search action',
      eventAction: 'tab selected',
      eventLabel: tab,
    }),
  )
}

export const trackReminderClickEvent = ({
  numberOfReminders,
  searchTerm,
  index,
  department,
}: {
  numberOfReminders: number
  searchTerm: string
  index: number
  department: string
}) => {
  trackGAEvent(
    createReminderSuggestionEvent({
      event: 'search_suggestion_click',
      eventAction: 'suggestion clicked',
      eventLabel:
        `${searchTerm} | ${index} / ${numberOfReminders} | reminders`.toLowerCase(),
      index,
      numberOfResults: numberOfReminders,
      searchTerm,
      productCategory: departmentToCategory(department),
    }),
  )
}

export const trackRemindersViewedEvent = ({
  numberOfReminders,
  department,
  trackGAEventOnce,
}: {
  numberOfReminders: number
  department: string
  trackGAEventOnce: (event: EventObject) => void
}) => {
  trackGAEventOnce(
    createReminderSuggestionEvent({
      event: 'search_suggestion',
      eventAction: 'suggestions displayed',
      eventLabel: 'no input',
      eventValue: numberOfReminders,
      numberOfResults: numberOfReminders,
      productCategory: departmentToCategory(department),
    }),
  )
}
